"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

var _H = _interopRequireDefault(require("../H1"));

var _H2 = _interopRequireDefault(require("../H2"));

var _H3 = _interopRequireDefault(require("../H3"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headers = {
  '1': _H.default,
  '2': _H2.default,
  '3': _H3.default
};

var BareIconHeader = function BareIconHeader(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? '1' : _ref$level,
      Icon = _ref.icon,
      children = _ref.children,
      className = _ref.className;
  var Header = headers[level];
  return _react.default.createElement("div", {
    className: className
  }, Icon && _react.default.createElement(Icon, null), _react.default.createElement(Header, null, children));
};

var IconHeader = (0, _styledComponents.default)(BareIconHeader).withConfig({
  displayName: "IconHeader",
  componentId: "sc-1fm9ixk-0"
})(["display:flex;align-items:center;color:", ";svg{flex-shrink:0;width:40px;height:40px;margin-right:16px;fill:", ";}"], (0, _helpers.color)('brand'), (0, _helpers.color)('brand'));
var _default = IconHeader;
exports.default = _default;